import { FC } from 'react'
import { ModalSectionProps, RotaPatternModalType } from '../utils'
import {
  DateTimeWindowSection,
  FrequencyResultSection,
  ReccurencePatternSection,
} from '../sections'

export const ReccurenceStep: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ formData, setFormData, form, type }) => {
  return (
    <>
      <DateTimeWindowSection
        formData={formData}
        setFormData={setFormData}
        form={form}
      />
      <ReccurencePatternSection formData={formData} setFormData={setFormData} />
      <FrequencyResultSection form={form} type={type} formData={formData} />
    </>
  )
}
